// extracted by mini-css-extract-plugin
module.exports = {"progress":"PaymentLogSubmitProgress_progress__3WmHS","message":"PaymentLogSubmitProgress_message__idnef"};